import clsx from "clsx";
import type { ContentStatus } from "@/api/profiles";
import styles from "./StatusPill.module.css";

/** Human-readable label for each content status. */
export const CONTENT_STATUS_LABELS: Record<ContentStatus, string> = {
  draft: "Draft",
  published: "Published",
};

export type StatusPillSize = "sm" | "md";

export type StatusPillProps = {
  status: ContentStatus;
  size?: StatusPillSize;
  className?: string;
};

/**
 * Read-only pill showing a content record's lifecycle status.
 *
 * Mirrors the account-ui `StatusPill` — status is driven by the persisted
 * record (and by which `SaveActions` button the user presses), never an
 * editable control.
 */
export function StatusPill({ status, size = "md", className }: StatusPillProps) {
  return (
    <span
      className={clsx(styles.pill, styles[status], styles[size], className)}
      data-status={status}
    >
      {CONTENT_STATUS_LABELS[status]}
    </span>
  );
}

export default StatusPill;
